import React from 'react';
import styled from 'styled-components';
import { MDIIcon } from '../MDIIcon';
import { type MDIIconButtonProps } from './MDIIconButton.types';

/**
 * Renders an unstyled button with a Material Design icon inside.
 * See https://materialdesignicons.com/ for a list of available icons.
 */
const MDIIconButton = React.forwardRef(function MDIIconButton(
  props: MDIIconButtonProps,
  forwardedRef: React.Ref<HTMLButtonElement> | null,
) {
  return (
    <StyledButton
      title={props.title}
      onClick={props.onClick}
      $svgFill={props.fill}
      className={props.className}
      disabled={props.disabled}
      ref={forwardedRef}
      data-testid={props.dataTestId}
    >
      <MDIIcon icon={props.icon} size={props.iconSize} />
    </StyledButton>
  );
});

export default React.memo(MDIIconButton);

const StyledButton = styled.button<{ $svgFill?: string }>`
  margin: 0;
  display: inline-block;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: opacity 0.5s;
  opacity: 0.8;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  ${({ $svgFill }) => ($svgFill ? `svg { fill: ${$svgFill}; }\n` : '')}
`;
